const productBannerBottom = document.querySelector('.product-banner-bottom');
const boundaryUpperElement = document.querySelector('.product-single__form');
const boundaryBottomElement = document.querySelector('#shopify-section-footer');
const header = document.querySelector('.site-header')

const bannerInterval = setInterval(checkBanner, 100);

function checkBanner() {
  const upperRect = boundaryUpperElement.getBoundingClientRect();
  const bottomRect = boundaryBottomElement.getBoundingClientRect();

  const offset = header.classList.contains('site-header--stuck') ? header.getBoundingClientRect().height : 0;
  
  if (0 > upperRect.bottom - offset && bottomRect.top > window.innerHeight) {
    productBannerBottom.classList.add('active');
  } else {
    productBannerBottom.classList.remove('active');
  }
}